import React from 'react';
import { AppShell, Box } from '@mantine/core';

interface MenuLayoutProps {
  children: React.ReactNode;
}

/**
 * Lightweight layout component specifically for menu pages
 * Removes unnecessary navigation, auth, and admin features for faster loading
 * 
 * Structure:
 * - AppShell.Main: Fixed height (100vh), positioned relative (for absolute children)
 * - Content Box: Scrollable content area
 * - Bottom bar will be absolutely positioned relative to AppShell.Main (outside scroll area)
 */
const MenuLayout: React.FC<MenuLayoutProps> = ({ children }) => {
  return (
    <AppShell
      padding={0}
      header={undefined}
      navbar={undefined}
    >
      <AppShell.Main
        id="menu-layout-main"
        style={{
          height: '100vh', // Fixed height instead of min-height for mobile keyboard compatibility
          position: 'relative', // Makes this a positioned parent for absolute children
          overflow: 'hidden', // Prevents scrolling on the main container
        }}
      >
        <Box
          style={{
            height: '100%', // Full height of AppShell.Main
            width: '100%',
            maxWidth: '100%',
            margin: '0 auto',
            overflowY: 'auto', // Allow scrolling within content area
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch', // Enable momentum scrolling on iOS
          }}
        >
          {children}
        </Box>
      </AppShell.Main>
    </AppShell>
  );
};

export default MenuLayout;
